
const INTERCEPTOR_FLAG = "__API_INTERCEPTOR_INSTALLED__";

// ✅ CAMBIO: decodificador base64url (JWT normalmente viene en base64url, NO base64 estándar)
const decodeBase64Url = (str) => {
  try {
    let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    // padding
    while (base64.length % 4) base64 += "=";
    return atob(base64);
  } catch {
    return null;
  }
};

export const setupApiInterceptor = () => {
  // ✅ CAMBIO: evitar doble instalación en StrictMode (dev)
  if (window[INTERCEPTOR_FLAG]) return;
  window[INTERCEPTOR_FLAG] = true;

  const originalFetch = window.fetch;

  window.fetch = async (url, options = {}) => {
    const token = localStorage.getItem("token");

    // ✅ CAMBIO: determinar si es llamada a tu API (full URL o relativa con proxy)
    const urlStr = typeof url === "string" ? url : "";
    const isApiCall =
      urlStr.includes(process.env.REACT_APP_API_ROUTE) ||
      urlStr.startsWith("/"); // por si usas proxy o rutas relativas

    // ✅ CAMBIO: adjuntar Authorization SOLO si hay token y es API call
    if (token && isApiCall) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      };
    }

    const response = await originalFetch(url, options);

    // ✅ CAMBIO: SOLO hacer logout si:
    // - es llamada a la API
    // - status 401
    // - y realmente se envió Authorization (evita borrar token por 401 “porque no adjuntó header”)
    const sentAuth =
      !!(options.headers && (options.headers.Authorization || options.headers.authorization));

    // No disparar logout si el 401 viene de un endpoint de autenticación de terceros
    const isAuthEndpoint = urlStr.includes("autenticacionsucursalesbyusuario");

    if (isApiCall && response.status === 401 && sentAuth && !isAuthEndpoint) {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth:logout"));
    }

    return response;
  };
};

export const fetchWithToken = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("token");
    throw new Error("Token expirado o inválido");
  }

  return response;
};

// ✅ CAMBIO: isTokenValid robusto para JWT base64url
export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;

    const payloadStr = decodeBase64Url(parts[1]);
    if (!payloadStr) return false;

    const payload = JSON.parse(payloadStr);
    const currentTime = Date.now() / 1000;

    // margen 15s
    return typeof payload.exp === "number" && payload.exp > currentTime + 15;
  } catch (error) {
    console.error("Error al validar token:", error);
    return false;
  }
};

export const clearToken = () => {
  localStorage.removeItem("token");
};